// extracted by mini-css-extract-plugin
export default {"container":"style_container__NHO44","label":"style_label__+-EUt","fileWrapper":"style_fileWrapper__BOGMv","fileText":"style_fileText__w6HAw","placeholder":"style_placeholder__A8jPj"};